import { cleanFilters } from './tools'

export const updateSearch = (state, {search}) => {
  state.search = search
}

export const updateCategories = (state, {categories}) => {
  state.categories = categories
}

export const updateSubtypes = (state, {subtypes}) => {
  state.subtypes = subtypes
}

export const updateRarity = (state, {rarity}) => {
  state.rarity = rarity
}

export const updateModsRarity = (state, {modsRarity}) => {
  state.modsRarity = modsRarity
}

export const updateSets = (state, {sets}) => {
  state.sets = sets
}

export const updateSearches = (state, {searches}) => {
  state.searches = searches
  localStorage.setItem('searches', JSON.stringify(state.searches))
}

export const setOrdering = (state, {ordering}) => {
  state.ordering = ordering
}

export const updateDamageType = (state, {damageType}) => {
  state.damageType = damageType
}

export const updateVarious = (state, {various}) => {
  state.various = various
}

export const setTokens = (state, {tokens}) => {
  state.tokens = tokens
}

export const applyFilters = (state, {filters}) => {
  cleanFilters(state)
  Object.keys(filters).forEach(key => {
    state[key] = filters[key]
  })
}



// WEBPACK FOOTER //
// ./src/store/destiny/filters/mutations.js